import React, { FC } from 'react';

import { Box } from '@mui/material';

import useAddWorkshift from '../../../../hooks/workshift/useAddWorkshift';
import NotesField from '../../../common/NotesField/NotesField';

import WorkshiftForm from '../WorkshiftForm';
import classes from './styles';

interface IAdd {
  date: string;
}

const Add: FC<IAdd> = ({ date }) => {
  const { container } = classes;

  const { formik } = useAddWorkshift(date);

  return (
    <Box sx={container}>
      <WorkshiftForm formik={formik} customDateName="datePicker" isSeries />
      <NotesField formik={formik} />
    </Box>
  );
};

export default Add;
